<template>
  <div>
    <v-menu
      v-model="show"
      :close-on-content-click="false"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          outline
          v-model="formattedDate"
          :label="label"
          :append-icon="icon || 'event'"
          readonly
          validate-on-blur
          v-on="on"
          :rules="required"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="selectedDate"
        no-title
        @input="show = false"
        :allowed-dates="allowedDates"
      ></v-date-picker>
    </v-menu>
  </div>
</template>
<script>
import ValidationRules from '@/mixins/ValidationRules'
export default {
  props: {
    label: String,
    icon: String,
    noPreviousDates: Boolean,
    defaultValue: String
  },
  mixins: [
    ValidationRules
  ],
  data () {
    return {
      selectedDate: null,
      show: false,
      allowedDates: val => this.noPreviousDates ? window.moment(val).isSameOrAfter(window.moment().format('YYYY-MM-DD')) : true
    }
  },
  computed: {
    formattedDate: {
      get () {
        return this.selectedDate ? window.moment(this.selectedDate).format('DD/MM/YYYY') : window.moment(this.defaultValue).format('DD/MM/YYYY')
      },
      set (value) {
        this.selectedDate = value
      }
    }
  },
  watch: {
    selectedDate (value) {
      this.$emit('change', value)
    }
  }
}
</script>
